import toast from 'react-hot-toast'
import { AxiosError } from 'axios'

import { Container, Generic, Pallet, makeGeneric } from 'src/api/models'
import { skuit } from 'src/services/skuit'

import { Handler, HandlerInput } from './base'
import { Action, ApplyScan } from './interface'

interface LabelPrintingHandlerInput extends HandlerInput {
  obj: Generic
}

export class SetSSCCHandler extends Handler {
  obj: Generic
  container?: Generic
  error?: string

  constructor(props: LabelPrintingHandlerInput) {
    super(props)
    this.obj = props.obj
  }

  apply = ({ scanned, context, local }: ApplyScan): [Action, any | undefined] => {
    this.error = undefined
    switch (scanned.object.type) {
      case Pallet.type:
      case Container.type: {
        skuit.sc.freight.shipments.pallets
          .retrieve(this.obj.object.guid, scanned.object.guid)
          .then((container) => {
            this.container = makeGeneric(container)
            this.notify({})
          })
          .catch((error: AxiosError) => {
            toast.error(`Invalid container. "${error.response?.data}"`)
          })
        return [Action.Invalid, undefined]
      }
    }
    return [Action.Invalid, undefined]
  }

  setSSCC = (sscc: string) => {
    if (this.container) {
      skuit.sc.freight.shipments.pallets
        .patch(this.obj.object.guid, this.container.object.guid, {
          sscc_code: sscc,
        })
        .catch((error) => {
          this.error = error.response.data.sscc_code[0]
          this.notify({})
        })
    }
    this.container = undefined
    this.notify({})
  }

  getContext = () => {
    return { activity: 'label_printing', obj: this.obj.object.guid }
  }
}
